
import React from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';

interface DeleteDatabaseDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  database: any;
  onDelete: (id: string) => void;
}

const DeleteDatabaseDialog: React.FC<DeleteDatabaseDialogProps> = ({ 
  open, 
  onOpenChange,
  database,
  onDelete
}) => {
  const handleDelete = () => {
    onDelete(database.id);
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to delete this database?</AlertDialogTitle>
          <AlertDialogDescription>
            You are about to delete the connection to <strong>{database.name}</strong>. 
            This action cannot be undone and may affect any systems or reports that rely on this data source.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDatabaseDialog;
